import React, { useEffect, useState } from 'react'

const OnlineStatus = ({ lastActiveDate }) => {
    const [ status, setStatus ] = useState()

    useEffect(() => {
        if (!lastActiveDate) {
            return
        }

        let status = 'offline'

        const secondsDifference = (new Date() - new Date(lastActiveDate + "+00:00")) / 1000

        if (secondsDifference <= 120) { // 2 minutes - online
            status = 'online'
        } else if (secondsDifference <= 60 * 60 * 12) { // last 12 hours - away
            status = 'away'
        }

        setStatus(status)
    }, [ lastActiveDate ])

    if (!status) {
        return <></>
    }

    const statusTitle = {
        'online': 'Online',
        'away': 'Recently online',
        'offline': 'Offline'
    }

    return <span className={`online-status ${status}`} title={statusTitle[status]} />
}

export default OnlineStatus